<div class="claim-quantity-input" [ngClass]="{
  'color-red': errorTypes.includes('qty_error'),
  'color-disabled': errorTypes.includes('invalid_error') || hasDisplayText
}">
  <div (click)="decrease()" class="minus flex-center" [ngClass]="{'disabled': isMinusPlusDisabled}">
    <svg-icon *ngIf="!isMinusPlusDisabled" [iconName]="'new/minus.svg'"></svg-icon>
    <svg-icon *ngIf="isMinusPlusDisabled" [iconName]="'new/minus-grey.svg'"></svg-icon>
  </div>
  <nz-input-group class="text-center">
    <input
      *ngIf="hasDisplayText"
      nz-input
      type="text"
      disabled
      [ngModel]="displayText"
      title=""
      autocomplete="off"
      placeholder=""
    />
    <input
      *ngIf="!hasDisplayText"
      nz-input
      type="number"
      [disabled]="errorTypes.includes('invalid_error')"
      [(ngModel)]="quantity"
      [ngStyle]="errorTypes.includes('invalid_error') ? null : (errorTypes.includes('qty_error') ? {color: '#ED0007' }:(errorTypes.includes('qty_warning') ? {color: '#18837E' }:{}))"
      (blur)="onBlur()"
      (change)="onBlur()"
      (ngModelChange)="onInputChange($event)"
      [attr.min]="moq"
      [attr.step]="moq"
      title=""
      autocomplete="off"
      placeholder=""
    />
  </nz-input-group>
  <div (click)="increase()" class="plus flex-center" [ngClass]="{'disabled': isMinusPlusDisabled}">
    <svg-icon *ngIf="!isMinusPlusDisabled" [iconName]="'new/plus.svg'"></svg-icon>
    <svg-icon *ngIf="isMinusPlusDisabled" [iconName]="'new/plus-grey.svg'"></svg-icon>
  </div>
</div>
